var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"additional-properties-list"},[_c('ul',{staticClass:"additional-properties-list__list"},_vm._l((_vm.propertiesByDate),function(day,index){return _c('li',{key:index,staticClass:"additional-properties-list__row"},[_c('WigPageAdditionalPropertiesByDateItem',{attrs:{"day":day}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }